module.exports = __webpack_public_path__ + "img/case-ct_revoltcapsule_top.a1f9354.png";